<template>
  <div id="home">

    <div class="scrollView"  @scroll="elementScroll($event)">

      <img v-if="specsub_imgthumb" :src="specsub_imgthumb" class="bg_img">
      <div class="desc" v-if="desc" v-html="desc"></div>
      <div v-for="(item,item_index) in list" :key="item.art_id">
        <rightImg v-if="item.type==1 || item.type==9" :data="item"></rightImg>
        <leftImg  v-if="item.type==52" :data="item"  ></leftImg>
        <onelyTxt v-if="item.type==2" :data="item" :is_spec="true"></onelyTxt>
        <bigImgDesc v-if="item.type==50 || item.type==51" :data="item" ></bigImgDesc>

        <threeImg v-if="item.type==3 || item.type==10" :data="item" ></threeImg>
        <bigImg v-if="item.type==4 || item.type==7" :data="item" :is_spec="true"></bigImg>
        <newsVideoItem v-if="item.type==5" :data="item" currentpath="../../../"  :is_spec="true" ></newsVideoItem>
        <zhuanTi v-if="item.type==14" :data="item"></zhuanTi>







      </div>
      <!-- loading-->
      <div v-if="showloading && !loadend" class="bottom-loading">
        <van-loading size="24px">加载中...</van-loading>
      </div>

    </div>


    <div class="c-loading" v-if="loading">
      <div class="c-loading-c">
        <img src="../assets/loading.svg">
        <div>加载中...</div>
      </div>

    </div>

  </div>
</template>
<style >

  header{ display: flex; justify-content: space-between; align-items: center; height: 60px; font-size: 16px; color: #222222;text-align: center;
     padding-right: 15px; box-sizing: border-box; border-bottom: 0.5px solid #eaeaea;
  }
  .back img{ height: 18px; display: block}


  .header-start,.header-end{ display: flex;align-items: center; width: 80px;}

  .header-end{ justify-content: flex-end;height: 20px}
  #home{ height: 100vh;position: fixed; width: 100%; left: 0; top:0; display: flex; flex-direction: column}


  .header{ position: fixed; width: 100%; left: 0; top:0; background-color: #fff;z-index: 1000;}
  .bg_img{ width: 100%}
  header .text-overflow-one{width: 60%;text-align: center;}

  .labels_warp{ width: 100%; height: 40px; padding: 0 15px;border-bottom: 0.3px solid #eaeaea;}
  .labels_cont{ width: 100% ;display: flex}
  .labels_item{ height: 40px; line-height: 40px; padding: 0 15px; font-size: 16px; color: #3e3e3e}
  .labels_item.active{color: red}
  .back2{ position: fixed; left:0; top:0; z-index: 1; height: 75px;  display: flex;  align-items: center }
  .back2 .back2-warp{ display: flex; justify-content: center; align-items: center;width: 50px; height: 50px;}
  .back2  img{height: 18px; display: block}
  .back2-warp div{display: flex; justify-content: center; align-items: center; width: 30px; height: 30px; border-radius: 50%; }
  .noimghead{ width: 100%; height: 60px}
  .is_spec{ display: none !important;}
  .desc{ padding:15px 40px;color: #626262; font-size: 14px; line-height: 26px;letter-spacing: 1.5px; background-image: url("../assets/icon-yinhao@2x.png"); background-repeat: no-repeat; background-position: 15px 15px; background-size: 16px; border-bottom: 5px solid #f4f5f7}


</style>
<script>
  import { ImagePreview } from 'vant';
// @ is an alias to /src
import leftImg from '@/components/leftImg.vue'
import rightImg from '@/components/rightImg.vue'
import onelyTxt from '@/components/onelyTxt.vue'
import bigImgDesc from '@/components/bigImgDesc.vue'
import newsVideoItem from '@/components/newsVideoItem.vue'
import bigImg from '@/components/bigImg.vue'
import threeImg from '@/components/threeImg.vue'
import zhuanTi from '@/components/zhuanTi.vue'





  import request from "../utils/request";
  import utils from "../utils";

export default {
  name: 'SpecialList',
  components: {
    leftImg,
    rightImg,
    onelyTxt,
    bigImgDesc,
    newsVideoItem,
    bigImg,
    threeImg,
    zhuanTi
  },
  data: function(){
    return {
      show_no_internet: false,

      hide: false,
      list: [],
      page: 1,
      showloading: true,
      loadend: false,
      scrolltop: 0,
      title:"专栏",
      specsub_imgthumb:"",
      header_opactiy:1,
      loading:true,
      desc:""
    }
  },

  created: function created() {
    this.show = true;
    this.getdata();
  },
  mounted() {
    document.querySelector(".toplink").style.display = 'none';
  },
  watch: {
    $route: function (newVal,oldVal) {
      if(oldVal.name===newVal.name){
        this.list = [];
        this.page = 1;
        setTimeout(()=>{
          this.getdata();
        },10)
      }
    }
  },
  methods: {


    setdefaultImg: function setdefaultImg(event) {
      var el = event.currentTarget;
      el.style.opacity = 0;
    },
    //TextAre换行符
    TextAreaText2Html: function TextAreaText2Html(str) {
      if (!str) {
        return "";
      }
      var reg = /\n/gim;
      var reg1 = /\r/gim;
      var reg3 = /\n\r/gim;
      var reg4 = /\s/gim;
      str = str.replace(reg3, "<br/>");
      str = str.replace(reg, "<br/>");
      str = str.replace(reg1, "<br/>");
      str = str.replace(reg4, "&nbsp;");

      return str;
    },
    //获取数据
    getdata: function getdata() {
      var _this = this;


      var page = this.page;
      request.get_zhuanlan_lists(this.$route.params.id, page, function (res, err) {
        // console.log(JSON.stringify(res))
        _this.loading = false;
        if(!res.banner_thumb){
          _this.header_opactiy =1
        }else{
          _this.specsub_imgthumb = res.banner_thumb
        }
        if (err) {
          _this.show_no_internet = true;
          _this.showloading = false;
          return;
        }

        if(res.title){
          _this.title = res.title;
          document.title = res.title
        }

        if (res && res.code == 200) {
          //没有数据
          if (res.data.length === 0) {
            _this.loadend = true;
            _this.showloading = false;
            return;
          }else if(res.data.length<10){
            _this.loadend = true;
            _this.showloading = false;
          }



          var list = _this.list.concat(res.data);

          _this.list = utils.arrayDelRepeat(list, 'art_id');
          _this.page++;


          if(res && res.title){
            request.getWeixinShanre(location.href,(s_res)=>{
              let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
              let shareconfig = {appId,timestamp,nonceStr,signature};
              if(utils.is_weixin()){
                if(res.data){
                  let sharedata = {
                    title:res.title?res.title:"看度时政",
                    desc:res.desc,
                    link:location.href,
                    imgUrl:thumb
                  };
                  utils.setWeiXinShare(sharedata,shareconfig,false)
                }

              }
            });
          }
          if(res.desc && res.desc !=="求证新闻真相"){
            _this.desc = _this.TextAreaText2Html(res.desc)
            // _this.desc = res.desc
          }

        }
      });
    },
    elementScroll: function elementScroll(e) {
      var _this2 = this;

      this.scrolltop = e.target.scrollTop; //滚动到了底部

      if(this.specsub_imgthumb){
        var opactiy = e.target.scrollTop/100;
        if(opactiy<0){
          opactiy = 0
        }else if(opactiy>1){
          opactiy = 1
        }
        this.header_opactiy = opactiy;
      }
      if (this.scrollbottom) {
        var topheight = e.target.offsetHeight + e.target.scrollTop;

        if (topheight + 30 >= e.target.scrollHeight && this.lastscroll < e.target.scrollTop) {
          if (this.scrollTopTimeOut) {
            clearTimeout(this.scrollTopTimeOut);
            this.scrollTopTimeOut = false;
          }

          this.scrollTopTimeOut = setTimeout(function () {
            _this2.scrollbottom();
          }, 300);
        }

        this.lastscroll = e.target.scrollTop;
      }
    },
    scrollbottom: function scrollbottom() {
      this.getdata();
    }
  }
}
</script>
